import { render, staticRenderFns } from "./InputKardOnHands.vue?vue&type=template&id=61b5fb78&scoped=true&"
import script from "./InputKardOnHands.vue?vue&type=script&lang=js&"
export * from "./InputKardOnHands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b5fb78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VContainer,VRadio,VRadioGroup})
